import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AuthPageStyles } from '../../authentication/styles';
import { useAppSelector } from '../../store/hook';
import StageCompletionStyles from '../../staticPages/styles/stageCompletion';
import { ReactComponent as SystemError } from '../images/system_error.svg';
import PaperContainer from '../../authSimplified/components/PaperContainer';
import { StaticPageIconStyles } from '../../common/styles/staticPageIcon';

/** Component for general error page with localized message 'Internal Server Error '*/
const ErrorPage = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  const { classes: stageCompletionClasses } = StageCompletionStyles();
  const { classes: StaticPageIconClasses } = StaticPageIconStyles();
  const { classes } = AuthPageStyles({ isICPEnabled: isICPEnabled });

  return (
    <PaperContainer variant="medium">
      <Box textAlign="center">
        <Grid container justifyContent="center" className={classes.container}>
          <Grid item xl={8} lg={7}>
            <Box className={stageCompletionClasses.stageCompletionHeading} pt={2.5}>
              <SystemError width="120px" height="120px" className={StaticPageIconClasses.staticPageIcon} />
              <Typography variant="h1">{t('systemError')}</Typography>
            </Box>
            <Box className={stageCompletionClasses.stageCompletionText} pb={2.5}>
              <Box textAlign="center">{t('systemErrorMessage1')}</Box>
              <Box textAlign="center" mt={2}>
                {t('systemErrorMessage2')}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </PaperContainer>
  );
};

export default ErrorPage;
